module.exports = __webpack_public_path__ + "img/Background8.8cd4d71a.png";